/**
 * Local tour list filtering + MCP vs cached selection — mirrors iOS TourCatalogSearch.
 */

import type { ViatorProduct } from '../services/viatorProductsService';

export function filterToursLocally(products: ViatorProduct[], query: string): ViatorProduct[] {
  const trimmed = query.trim();
  if (!trimmed) return products;
  const needle = trimmed.toLowerCase();
  return products.filter((product) => {
    if (product.title.toLowerCase().includes(needle)) return true;
    if (product.description.toLowerCase().includes(needle)) return true;
    return product.categories.some((c) => c.toLowerCase().includes(needle));
  });
}

/**
 * Empty query → cached catalog.
 * Query matches last submitted MCP search → MCP products as-is.
 * Otherwise → local filter of cached catalog.
 */
export function visibleViatorProducts(options: {
  cached: ViatorProduct[];
  query: string;
  submittedQuery: string | null | undefined;
  mcpProducts: ViatorProduct[] | null | undefined;
}): ViatorProduct[] {
  const trimmed = options.query.trim();
  if (!trimmed) return options.cached;

  const submitted = options.submittedQuery?.trim() ?? '';
  if (
    submitted &&
    submitted.toLowerCase() === trimmed.toLowerCase() &&
    options.mcpProducts != null
  ) {
    return options.mcpProducts;
  }

  return filterToursLocally(options.cached, trimmed);
}
